export const SET_STARTING_POINT = "SET_STARTING_POINT";
export const SET_DESTINATION = "SET_DESTINATION";

interface ActionTypes {
  SET_STARTING_POINT: any;
  SET_DESTINATION: any;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setStartingPoint(startingPoint: any): DirectionsActionsTypes {
  return {
    type: SET_STARTING_POINT,
    payload: startingPoint,
  };
}

export function setDestination(destination: any): DirectionsActionsTypes {
  return {
    type: SET_DESTINATION,
    payload: destination,
  };
}

export type DirectionsActionsTypes = MessageAction;
